import { Select, TextInput } from '@ally/forms'
import { Accordion, Box, TextBody, upToMd } from '@ally/metronome-ui'
import React from 'react'
import allytm from '@ally/allytm'
import { STATES } from '../../utils/constants'

export const BeneficiaryAddress: React.FC<{
  zipCodeError?: string
  handleZipCodeChange: (value: string) => void
  handleInputChange: (name: string, value: string) => void
  handleStateChange: (value: string) => void
  isOutsideTheUS?: boolean
}> = ({
  zipCodeError,
  handleZipCodeChange,
  handleInputChange,
  handleStateChange,
  isOutsideTheUS,
}) => {
  const validateZip = (val: string): string => {
    if (zipCodeError) {
      allytm.event(
        'customError',
        `The ZIP code doesn't match the state you entered. Please check your information and try again.`,
      )
      return zipCodeError
    }
    // istanbul ignore next // we can remove this ignore once we apply an integration testing for this form
    return ''
  }

  const options = STATES.map(state => {
    return {
      label: state.ID,
      value: state.ID,
    }
  })

  return (
    <>
      <Box width={upToMd('88%', '50%')} my="md">
        <TextInput
          isPrivate
          labelContent="Street Address"
          name="addressLine1"
          inputType="text"
          maxLength={40}
          data-testid="street-address-input"
          onChange={(event): void =>
            handleInputChange('addressLine1', event.target.value)
          }
          // Disable the input if the beneficiary's country is outside the U.S.
          disabled={isOutsideTheUS}
        />
      </Box>
      <Box width={upToMd('88%', '50%')} mb="md">
        <TextInput
          isPrivate
          labelContent="Address line 2 (optional)"
          data-testid="address-line-2"
          name="addressLine2"
          inputType="text"
          maxLength={40}
          onChange={(event): void =>
            handleInputChange('addressLine2', event.target.value)
          }
          // Disable the input if the beneficiary's country is outside the U.S.
          disabled={isOutsideTheUS}
        />
      </Box>

      <Box width={upToMd('88%', '50%')} mb="md">
        <TextInput
          isPrivate
          labelContent="City"
          name="city"
          inputType="text"
          maxLength={32}
          onChange={(event): void =>
            handleInputChange('city', event.target.value)
          }
          // Disable the input if the beneficiary's country is outside the U.S.
          disabled={isOutsideTheUS}
        />
      </Box>
      <Box width={upToMd('88%', '50%')} mb="md">
        <Select
          name="state"
          options={options}
          label="State"
          placeholder="Select"
          onChange={(event): void => handleStateChange(event.target.value)}
          // Disable the input if the beneficiary's country is outside the U.S.
          isDisabled={isOutsideTheUS}
        />
      </Box>
      <Box width={upToMd('88%', '50%')} mb="md">
        <TextInput
          isPrivate
          labelContent="ZIP code"
          name="zipCode"
          inputType="text"
          validate={validateZip}
          maxLength={10}
          onChange={(e): void => handleZipCodeChange(e.target.value)}
          // Disable the input if the beneficiary's country is outside the U.S.
          disabled={isOutsideTheUS}
        />
      </Box>
      <Accordion
        disableContainer
        items={[
          {
            heading: 'Is this address outside the U.S.?',
            panel: (
              <TextBody size="md" tag="span" tabIndex={-1}>
                Please call us at 1-877-247-2559 to edit this address. If you
                are calling from outside the US, the number is 1-757-247-2559.
              </TextBody>
            ),
          },
        ]}
      />
    </>
  )
}
